import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

function ModalQuestionToEpdTmpl({ show, onHide, submit }) {
  const [val, setVal] = useState();
  function handleChangeTitle(e) {
    setVal(e.target.value);
  }
  function onShow() {
    setVal(false);
  }
  function handleOnHide() {
    onHide();
    setVal();
  }
  return (
    <>
      <Modal show={show} onHide={handleOnHide} onShow={onShow}>
        <ModalHeader closeButton>
          <h5 className="modal-title">Generate EPD Template</h5>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <div className="mb-3">
              <label htmlFor="exampleFormControlInput1" className="form-label">
                Training Title
              </label>
              <input type="text" onChange={handleChangeTitle} className="form-control" id="exampleFormControlInput1" placeholder="2PK0021_PK Pompa Air" />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button onClick={() => submit(val)} type="button" className="btn btn-outline-theme">
            Generate
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalQuestionToEpdTmpl;
